import { render, staticRenderFns } from "./StatusExpired.vue?vue&type=template&id=423a65ca&scoped=true"
import script from "./StatusExpired.vue?vue&type=script&lang=js"
export * from "./StatusExpired.vue?vue&type=script&lang=js"
import style0 from "./StatusExpired.vue?vue&type=style&index=0&id=423a65ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a65ca",
  null
  
)

export default component.exports